$(document).ready(function () {
    $("#form-filter").submit(function(event) {
        event.preventDefault(); 
        window.history.pushState({}, null, $(this).attr('action'));

        let formdata = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: formdata,
            success: function (data) {
                $('#list-product').html(data.product);
                if(data.category) {
                    $('#titleCaption').html(data.category.name);
                }
                $('#breadDetail').remove();
                $('html, body').animate({
                    scrollTop: $("#list-product").offset().top
                }, 1000);
            },
        });
    });

    $(document).on('click', '#pagination-category a', function(event) {
        event.preventDefault();
        $('#form-filter').attr('action', $(this).attr('href')).submit();
    })

    $(document).on('change', '#input-sort', function(event) {
        event.preventDefault();

        let order = $(this).val(),
            url = window.location.href.split('?')[0];
            url += '?page=1';
    
        $("input[name=order][value='" + order + "']").prop('checked', true);
        $('#form-filter').attr('action', url).submit();
    })
})

window.setUrlForm = function(url) {
    $('#form-filter').attr('action', url);
}

window.resetFilter = function(url) {
    $('#form-filter')[0].reset();
    $('#form-filter').attr('action', url).submit();

}

window.checkedAll =function (e) {
    $('input.'+ $(e).attr("class") +':checkbox').not(this).prop('checked', e.checked);
}